import React from 'react';
const Contractors = () => <div className="service-page"><h1>Contractors</h1><p>Find reliable contractors for construction and renovation projects.</p></div>;
export default Contractors;
